// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.
import tocbot from 'tocbot';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import intersect from '@alpinejs/intersect';

window.tocbot = tocbot;

Alpine.plugin(collapse);
Alpine.plugin(focus);
Alpine.plugin(intersect);

// Global store
Alpine.store('data', {
	showMainNav: false
});

window.Alpine = Alpine;

Alpine.start();